/**
 * TipoRelatorio
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {FormatoArquivoRelatorio} from '@/model/resource/FormatoArquivoRelatorio'
import {TipoRelatorioCollection} from '@/model/collection/TipoRelatorioCollection'

/* TODO: review generated class */
export class TipoRelatorio extends Resource {
  idTipoRelatorioPk: number = 0

  @ResponseSerialize(FormatoArquivoRelatorio)
  formatoArquivoRelatorio: FormatoArquivoRelatorio | null = null

  descricao: string | null = null

  get $id() {
    return this.idTipoRelatorioPk
  }
  set $id(val) {
    this.idTipoRelatorioPk = val
  }

  get idFormatoArquivoRelatorioFk() {
    if (!this.formatoArquivoRelatorio) return 0
    return this.formatoArquivoRelatorio.$id
  }
  set idFormatoArquivoRelatorioFk(val) {
    if (!this.formatoArquivoRelatorio)
      this.formatoArquivoRelatorio = new FormatoArquivoRelatorio()
    this.formatoArquivoRelatorio.$id = val
  }

  /**
   * Gets a instance of a given ID of TipoRelatorio
   */
  async getTipoRelatorio(id: number) {
    return await Request.get(`/admin/tipo-relatorio/${id}`)
      .name('getTipoRelatorio')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of TipoRelatorio
   */
  static async listTipoRelatorio(params: any) {
    return await Request.get(`/admin/tipo-relatorio`, {params})
      .name('listTipoRelatorio')
      .as(TipoRelatorioCollection)
      .getData()
  }

  /**
   * Persists a new instance of TipoRelatorio. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistTipoRelatorio() {
    return await Request.post(`/admin/tipo-relatorio`, this)
      .name('persistTipoRelatorio')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of TipoRelatorio to use it in a CSV file
   */
  static async listCsvTipoRelatorio(params: any) {
    return await Request.get(`/admin/tipo-relatorio/csv`, {params})
      .name('listCsvTipoRelatorio')
      .as(TipoRelatorioCollection)
      .getData()
  }
}
